import { enviroment as devEnvironment } from './enviroment';
import { enviroment as mainEnvironment } from './enviroment.main';
import { enviroment as developEnvironment } from './enviroment.develop';

/**
 * Returns the appropriate environment configuration based on the current mode
 */
export function getEnvironment() {
  // Check if we're in production mode
  if (import.meta.env.MODE === 'production') {
    return mainEnvironment;
  }

  // Check if we're in development server mode
  if (import.meta.env.MODE === 'development') {
    return developEnvironment;
  }

  // Default to local development environment
  return devEnvironment;
}
